export class SetLastUpdate {
	static readonly type = '[GlobalConfiguration][ENUMS] SetLastUpdate';
}

export class SetTrackingSystems {
	static readonly type = '[GlobalConfiguration][ENUMS] SetTrackingSystems';
}

export class SetHandleMode {
	static readonly type = '[GlobalConfiguration][ENUMS] SetHandleMode';
}

export class SetActionOptions {
	static readonly type = '[GlobalConfiguration][ENUMS] SetActionOptions';
}

export class SetCMPOnHoldReasons {
	static readonly type = '[GlobalConfiguration][ENUMS] SetCMPOnHoldReasons';
}

export class SetReceiveFromClientOptions {
	static readonly type = '[GlobalConfiguration][ENUMS] SetReceiveFromClientOptions';
}

export class SetOrigins {
	static readonly type = '[GlobalConfiguration][ENUMS] SetOrigins';
}

export class SetProductTypes {
	static readonly type = '[GlobalConfiguration][ENUMS] SetProductTypes';
}

export class SetInspectionTypes {
	static readonly type = '[GlobalConfiguration][ENUMS] SetInspectionTypes';
}

export class SetRetryActions {
	static readonly type = '[GlobalConfiguration][ENUMS] SetRetryActions';

	constructor(public integrationName: string) {}
}

export class SetUAD36FieldTypes {
	static readonly type = '[GlobalConfiguration][ENUMS] SetUAD36FieldTypes';
}

export class ClearGlobalConfigEnums {
	static readonly type = '[GlobalConfiguration][ENUMS] ClearGlobalConfigEnums';
}
